import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const ICON_WIDTH = "34px";

export const Title = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_High_Emphasis,
    marginBottom: theme.spacing.small,
}));

export const PointWrapper = styled.div(({ theme }) => ({
    padding: theme.spacing.medium,
    boxShadow: theme.elevation[theme.colorMode].skim.boxShadow,
    borderRadius: theme.cornerRadius.medium,
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.small,
}));

export const PointComponentWrapper = styled.div({
    display: "flex",
    alignItems: "center",
});

export const IconWrapper = styled.div({
    minWidth: ICON_WIDTH,
});

export const PointText = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Med_Emphasis,
    width: "80%",
}));
